<template>
  <div class="files-list-cell">
    <bdg-files-list :items="files" no-section-name />
  </div>
</template>

<script>
import BdgFilesList from "../../files-list/BdgFilesList";

export default {
  name: "FilesListCell",
  components: { BdgFilesList },
  props: {
    files: Array
  }
};
</script>

<style lang="scss" scoped>
.bdg-table {
  .table {
    .body {
      .body-row {
        .table-cell {
          .files-list-cell {
            @apply -my-3;
          }
        }
      }
    }
  }
}
</style>
